// 📁 store/balance/createBalanceSlice.ts

import { StateCreator } from 'zustand';
import { questionnaireInitialState, QuestionnaireState } from './questionnaireInitialState';
import { QuestionnaireOptions } from '../../hooks/useQuestionnaireQuery';
import { createFunctionalSetter } from '../storeCommons';

/**
 * @french
 * Interface des actions liées à l'import FEC (balance).
 */
export interface QuestionnaireActions {
  setLoading: (loading: boolean) => void;
  setQuestionnaireEnabled: (questionnaireEnabled: boolean) => void;
  setQuestionnaireId: (questionnaireId: string) => void;
  setFetchNew: (fetchNew: boolean) => void;
  setFileId: (fileId: string) => void;
  setQuestionnaireOptions: (
    updater: QuestionnaireOptions | ((prev: QuestionnaireOptions) => QuestionnaireOptions),
  ) => void;
  setPdfModalVisible: (pdfModalVisible: boolean) => void;
  setDownloading: (downloading: boolean) => void;
  reset: () => void;
}

/**
 * @french
 * Slice Zustand pour gérer l'état et les actions liés à la balance FEC.
 */
export const createQuestionnaireSlice: StateCreator<
  QuestionnaireState & QuestionnaireActions,
  [],
  [],
  QuestionnaireActions
> = (set, get) => ({
  setQuestionnaireEnabled: (questionnaireEnabled) => set({ questionnaireEnabled }),
  setLoading: (loading) => set({ loading }),
  setPdfModalVisible: (pdfModalVisible) => set({ pdfModalVisible }),
  setQuestionnaireId: (questionnaireId) => set({ questionnaireId }),
  setFetchNew: (fetchNew) => set({ fetchNew }),
  setFileId: (fileId) => set({ fileId }),
  setDownloading: (downloading) => set({ downloading }),
  setQuestionnaireOptions: createFunctionalSetter(get, set, 'questionnaireOptions'),
  reset: () => set(questionnaireInitialState),
});
